module.exports = __webpack_public_path__ + "media/images/icon-svg/plus-67e35783de74f1ccb8f98255469af95d.svg";